export default "__VITE_ASSET__e0d8e144__"